import { Typography } from '@mui/material';
import { ProjectAttrs, apiPost } from 'cdx-common';
import React from 'react';

export const PreviousProjectCodes = (props: { project: ProjectAttrs; }) => {

    const [previousProjects, setPreviousProjects] = React.useState<ProjectAttrs[]>([]);

    const [previousProjectData, setPreviousProjectData] = React.useState<Pick<ProjectAttrs, 'customerCompanyId' | 'mainContactId'>>({
        customerCompanyId: props.project.customerCompanyId,
        mainContactId: props.project.mainContactId
    });

    const fetchPreviousProjects = async () => {
        setPreviousProjects(await apiPost('projectPreviousProjects', { ...props.project }));
    };

    React.useEffect(() => { setPreviousProjectData({ customerCompanyId: props.project.customerCompanyId, mainContactId: props.project.mainContactId }); }, [props.project]);

    React.useEffect(() => {
        void fetchPreviousProjects();
    }, [previousProjectData]);

    return <Typography variant='caption' noWrap textOverflow='ellipsis'>
        {previousProjects.length ? <>Derniers projets : {previousProjects.map(pr => pr.code).join(', ')}</> : ''}
    </Typography>;
};
